import type Module from 'mini-common-schema/lib/schema/Module';
import { getCurrentModule } from 'mini-app-module-store/lib/selectors/getCurrentModule';
import { matchPath, useLocation } from 'mini-react-router-dom';

const calendarPaths = [
    '/view/:mode',
    '/view/:mode/bottomsheet/:id',
    '/view/:mode/sidepane/:id',
    '/view/:mode/quickcapture',
];

const peopleCardPathRegex = '/card/*';

export default function useRouteBasedVisibility(): boolean {
    const location = useLocation();
    switch (getCurrentModule()) {
        case 1:
            return (
                calendarPaths.find(path => {
                    const matched = matchPath(path, location.pathname);
                    return matched;
                }) !== undefined
            );
        case 2:
            return !matchPath(peopleCardPathRegex, location.pathname);
        default:
            return true;
    }
}
